module.exports = __webpack_public_path__ + "img/ic_qrcode_weibo.e1b41e8.png";